<template>
    <div class="detail-wrap" v-loading=loading>
        <div class="detail-content" v-bar>
            <div>
                <!-- 非会话模式begin -->
                <div v-if="!dialog&&detailItem.MailData.subject" id="section-print" class="print">
                    <div class="item-title">
                        <span>{{detailItem.MailData.subject}}</span>
                    </div>
                    <div class="item-detail">
                        <div class="mail-header">
                            <div class="img-block">
                                <img :src=detailItem.MailData.fromAvatar class="head-img">
                            </div>
                            <div class="info-box">
                                <div class="sender info-item">
                                    <label>发件人：</label>
                                    <div class="mail-address-block">
                                        <div class="address-box">
                                            <span class="name">{{detailItem.MailData.from}}</span>
                                            <!-- <dropmenu class="dropmenu" :address="detailItem.MailData.from" @update="initData"></dropmenu> -->
                                        </div>
                                        <span class="icons icon-important" v-if="detailItem.MailData.isUrgent"></span>
                                        <span class="icons icon-forward" v-if="detailItem.MailData.isFwd"></span>
                                    </div>
                                </div>
                                <div class="sender-to info-item" v-if=detailItem.MailData.to.length>
                                    <label>收件人：</label>
                                    <div class="mail-address-block">
                                        <div class="address-box" v-for="(v,k) in detailItem.MailData.to" :key=k>
                                            <span class="name">{{v}}</span>
                                            <!-- <dropmenu class="dropmenu" :address="v" @update="initData"></dropmenu> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="carbon-copy" v-if=detailItem.MailData.cc>
                                    <label>抄&nbsp;&nbsp;&nbsp;送：</label>
                                    <div class="mail-address-block">
                                        <div class="address-box" v-for="(v,k) in detailItem.MailData.cc" :key=k>
                                            <span class="name">{{v}}</span>
                                            <!-- <dropmenu class="dropmenu" :address="v" @update="initData"></dropmenu> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="carbon-copy" v-if='detailItem.MailData.bcc&&detailItem.MailData.from.indexOf(userInfo.email)!==-1'>
                                    <label>密&nbsp;&nbsp;&nbsp;送：</label>
                                    <div class="mail-address-block">
                                        <div class="address-box" v-for="(v,k) in detailItem.MailData.bcc" :key=k>
                                            <span class="name">{{v}}</span>
                                            <dropmenu class="dropmenu" :address="v" @update="initData"></dropmenu>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="recieve-time info-item">
                                    <label>时&nbsp;&nbsp;&nbsp;间：</label>{{(pathName==='send'||pathName==='draft'?detailItem.MailData.sendDate:detailItem.MailData.receivedDate) |mailDate}}</div> -->
                                <div class="accessory info-item" v-if="detailItem.MailData.attachmentSize">
                                    <label>附&nbsp;&nbsp;&nbsp;件：</label>
                                    <span class="accessory-text">{{detailItem.MailData.attachments[0].name}}（{{detailItem.MailData.attachmentSize|size}}）共{{detailItem.MailData.attachments.length}}个附件</span>
                                    <span class="see-attachments" v-scroll-attach>查看附件</span>
                                </div>
                                
                                <div class="recieve-time info-item">
                                    {{(pathName==='send'||pathName==='draft'?detailItem.MailData.sendDate:detailItem.MailData.receivedDate) |mailDate}}
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <iframe class="iframepage" :ref=detailItem.id frameBorder=0 width="100%"></iframe>
                        </div>
                        <div class="attachments" v-if="detailItem.MailData.attachmentSize">
                            <div class="attach-tit">
                                <span class="name">附件 {{detailItem.MailData.attachments.length}}个</span>
                                <span class="size">({{detailItem.MailData.attachmentSize|size}})</span>
                                <span class="bagdownall" @click="download('all',detailItem.MailData)">打包下载</span>
                                <span class="fr collapse-btn" @click="detailItem.attachVisible=true" v-show=!detailItem.attachVisible>
                                    <span class="icons icon-expand"></span>展开</span>
                                <span class="fr expand-btn" v-show=detailItem.attachVisible @click="detailItem.attachVisible=false">
                                    <span class="icons icon-collapse"></span>收起</span>
                            </div>
                            <ul class="list fix" v-show=detailItem.attachVisible>
                                <li class="item" v-for="(attach,index) in detailItem.MailData.attachments " :key=index>
                                    <span class="img-type icons " :class="getFileIcon(attach.name)"></span>
                                    <div class="msg">
                                        <p class="name">{{attach.name | subString(18)}}</p>
                                        <p class="size">({{attach.size|size}})</p>
                                    </div>
                                    <div class="ac-hover">
                                        <span class="icons icon-download" @click="download('one',attach)"></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <!-- <div class="quick-reply-wrap noborder">
                        <div class="reply-simple" @click="detailItem.replyVisible=true" v-show=!detailItem.replyVisible v-areafocus>
                            <span class="text">{{detailItem.replyTo}}</span>
                            <span class="icons icon-close"></span>
                        </div>
                        <div class="reply-box" v-show=detailItem.replyVisible>
                            <div class="tit">{{detailItem.replyTo}}
                                <span class="icons icon-close fr" @click="detailItem.replyVisible=false"></span>
                            </div>
                            <textarea class="reply" :placeholder=detailItem.replyTo v-model=detailItem.replyContent></textarea>
                            <div class="send-block">
                                <span class="text" @click="replyOp('quickReply',detailItem)">使用完整发信功能</span>
                                <span class="send-btn" @click="replyOp('sendNow',detailItem)">发送</span>
                            </div>
                        </div>
                    </div> -->
                </div>
                <!-- 非会话模式end -->
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import mailToolBar from '@/components/mailtoolbar'
import dropmenu from '@/components/dropdown/dropmenu'
import {
    getMail,
    getSessionListMail,
    getMailListDetail,
    downloadAll,
    downloadOne,
    downloadFile,
    disposition,
    getNearIds,
    viewOrigin
} from '@/service/mailDetailService'
import { markRead } from '@/service/mailListService'
import { getFileIcon, sendMail } from '@/service/writeService'
import { mailsOperate, showMoveById, markStarOrNot } from '@/service/mailopService'
import router from '@/router'
import utils from '@/common/utils'
import $ from 'jquery'
export default {
    name: "readMail",
    props: {
        star: [Boolean, String]
    },
    data() {
        return {
            ids: [],
            sessionListMail: [],
            id: '',
            selectId: '',
            nextid: '',
            checkIds: [],
            checkVisible: false,
            pathName: 'recv',
            loading: false,
            showSpam: false,
            nextpage: false,
            prevpage: false,
            detailItem: {
                replyVisible: false,
                attachVisible: true,
                mailToolvisible: false,
                mailMovevisible: false,
                titleVisible: false,
                check: false,
                MailData: {}
            }
        }
    },
    components: {
        "mail-tool-bar": mailToolBar,
        "dropmenu": dropmenu
    },
    directives: {
        areafocus: {
            bind: function (el, binding) {
                $(el).on('click', () => {
                    setTimeout(() => {
                        $(el).next('.reply-box').find('textarea').focus()
                    }, 100)
                })
            }
        },
        // 附件滚动
        "scroll-attach": function (el, binding) {
            $(el).on('click', () => {
                $('.detail-content>.vb-content').animate({ scrollTop: $(el).parents('.item-detail').find('.attachments').offset().top + $('.detail-content>.vb-content').scrollTop() - $(el).offset().top }, 200)
            })
        }
    },
    computed: {
        ...mapState([
            'mailFolders',
            'mailsList',
            'list',
            'folderId',
            'mailSort',
            // 'limit',
            'searchText',
            'userInfo',
            'mailData',
            'baseSet',
            'dialog'
        ]),
        checkIdsOrsingle: function () {
            if (this.checkIds.length > 0) {
                return this.checkIds
            } else {
                return this.selectId ? [this.selectId] : []
            }
        },
        hideDel: function () {
            return /(draft|deleted|spam)/.test(this.pathName)
        },
        column: function () {
            return this.$route.query.id
        }
    },
    mounted() {
        this.initData()
    },
    methods: {
        ...mapActions([
            'getFolders',
            'getBaseSet'
        ]),
        showMoveById,
        markStarOrNot,
        getFileIcon,
        initData() {
            this.title = this.$route.path
            this.id = this.$route.query.id
            this.selectId = this.id
            this.checkIds = []
            this.detailItem.id = this.id
            this.openMailDetail(this.detailItem)
            setTimeout(()=>{
                window.print()                            
            },1000)
        },
        async getMailDetail(item) {
            let res = await getMail({
                id: item.id,
                folderId: this.folderId
            })
            item.MailData = res.data
            item.MailData.subject = item.MailData.subject || '无主题'
            this.dealMail(item)
        },
        async openMailDetail(item = { id: this.id }) {
            //没有选中文件时，打开详情取消可选状态
            if (!this.checkIds.length) {
                this.checkVisible = false
            }
            !this.column && (this.loading = true)
            await this.getMailDetail(item)
            this.loading = false
            this.selectId = item.id
            setTimeout(() => { 
                this.iframeFinish({ target: document.getElementsByTagName('iframe')[0] }, item) 
            }, 0)
        },
        dealMail(item) {
            // this.getNearIds(item.MailData.folderId)            
            let replyToArr = [item.MailData.from].concat(item.MailData.to)
            if (item.MailData.cc) replyToArr = replyToArr.concat(item.MailData.cc)
            $.unique(replyToArr)
            item.replyTo = '快速回复给：' + this.getFormatMails(this.getMailsNoOnes(replyToArr), 'nick').join('、')
            item.MailData.attachmentSize = item.MailData.attachments.reduce((pre, cur) => { return pre + cur.size }, 0)
        },
        getMailsNoOnes(arr, noOne) {
            if (!arr) {
                return
            }
            return arr.filter((v) => {
                let pureMail = v.match(/<(.*)>/)[1]
                return this.userInfo.email != pureMail && pureMail != '非法地址'
            })
        },

        /**
         * and:都带着昵称如a<a@a.com> 
         * or:有昵称的带着没有的不带且不带<> 
         * mail:纯邮箱都不带昵称  
         * nick:纯昵称 不带邮箱
        **/
        getFormatMails(inArr, flag) {
            if (!inArr || inArr.length == 0) return inArr
            if (!flag) flag = "or" // 默认
            let outArr = [], str, nick, mail, realNick
            for (let x = 0; x < inArr.length; x++) {
                if (!inArr[x]) break
                let matchs = inArr[x].match(/(.*)<((.+)@(.+))>/) || []
                realNick = matchs[1]
                mail = matchs[2]
                nick = realNick ? realNick : matchs[3]
                switch (flag) {
                    case "and":
                        str = nick + '<' + mail + '>'
                        break
                    case "or":
                        str = realNick ? (nick + '<' + mail + '>') : mail
                        break
                    case "mail":
                        str = mail
                        break
                    case "nick":
                        str = nick
                        break
                }
                outArr.push(str)
            }
            return outArr
        },
        onIdempty() {
            this.checkVisible = true
        },
        spamMails(id) {
            this.$reportSpam({
                show: true,
                ids: [id],
                list: this.list,
                folderId: this.folderId,
                callback: this.callback
            })
        },
        iframeFinish(event, item, load) {
            let iframe = event.target
            let receipt
            if (!iframe){
                return
            }
            try {
                if (iframe.contentWindow.document.body.innerHTML == item.MailData.display) {
                    return
                }
                if (!load) iframe.contentWindow.document.open()
                iframe.contentWindow.document.write(item.MailData.display)
                if (!load) iframe.contentWindow.document.close()
                receipt = this.userInfo.email != this.getFormatMails([item.MailData.from], 'mail')[0] && !item.MailData.hasRead && item.MailData.isReceipt && !item.MailData.hasReceipted
                $(iframe.contentWindow).on('click', function () {
                    $(window.parent.document.getElementsByClassName('content')).trigger('click')
                })
            } catch (e) {
                console.log(e)
            }
            let timer = setInterval(() => {
                try {

                    if (iframe.contentWindow && iframe.contentWindow.document.body) {
                        let idoc = iframe.contentWindow.document
                        var bHeight = idoc.body.scrollHeight
                        var dHeight = idoc.documentElement.scrollHeight
                        idoc.body.style['overflow-y'] = 'hidden'
                        idoc.body.style['word-wrap'] = 'break-word'
                        iframe.height = Math.max(bHeight, dHeight);
                    } else {
                        clearInterval(timer)
                    }
                } catch (e) {
                    console.log(e)
                }
            }, 100)
            setTimeout(function () {
                clearInterval(timer)
            }, 2500)
        },
    },
    watch: {
        '$route': function () {
            this.initData()
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../../assets/style/variables";
.detail-wrap {
    background: $white-smoke-color;
    height: 100%;
}
.tool-bar-box {
    .tool-page {
        position: absolute;
        right: 20px;
        top: 14px;
        .icon-pre-mail-hover,
        .icon-next-mail-hover {
            cursor: pointer;
        }
        .icon-pre-mail-hover:hover {
            background: url("../../assets/image/icon-pre-mail-hover2.png")
                no-repeat center 100%/100%;
        }
        .icon-next-mail-hover:hover {
            background: url("../../assets/image/icon-next-mail-hover2.png")
                no-repeat center 100%/100%;
        }
    }
}
.detail-content {
    background: #F3F3F3;
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.img-block {
    margin: 0 10px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    .img-checkbox {
        position: absolute;
        top: 0;
        left: 0px;
        width: 36px;
        height: 36px;
        background: rgba(0, 0, 0, 0.3);
        border: 1px solid #457eec;
        border-radius: 50%;
        visibility: hidden;
        &.check {
            background: #457eec;
        }
        &.visible {
            visibility: visible;
        }
        .icons {
            position: absolute;
            top: 11px;
            left: 11px;
        }
    }
    &:hover .img-checkbox {
        visibility: visible;
    }
}
.head-img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
}
.mail-item {
    cursor: pointer;
    &:first-child {
        margin-top: 0;
        .item-detail {
            border-top: 0;
        }
    }
    &:last-child {
        padding-bottom: 10px;
        .quick-reply-wrap {
            border-bottom: 0;
        }
    }
}
.item-simple {
    height: 73px;
    padding: 18px 0;
    border-bottom: 1px solid $light-gray-color;
    background: #fff;

    &.current {
        background-color: #fff1d3;
    }
    &:hover {
        background-color: #f3f3f3;
    }
    .info-box {
        display: inline-block;
        width: calc(100% - 72px);
        vertical-align: bottom;
        .icons {
            vertical-align: baseline;
            margin-right: 10px;
        }
    }
    .head-img {
        vertical-align: bottom;
    }
    .name {
        font-size: 14px;
        color: #000;
    }
    .date {
        display: inline-block;
        width: 100px;
        font-size: 12px;
        color: $dark-gray-color;
    }
    .suject {
        margin-top: 8px;
        font-size: 13px;
        color: $dim-gray-color;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: calc(100% - 210px);
    }
}
.item-title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    word-wrap: break-word;
    padding: 20px 200px 20px 20px;
    // border-bottom: 1px solid $light-gray-color;
    cursor: pointer;
    position: relative;
    .icons {
        vertical-align: baseline;
    }
    .icon-star,
    .icon-unstar {
        margin-left: 8px;
    }
    .icon-close-win{
        vertical-align: middle;
        margin-top: -6px;
    }
    .collapse-btn {
        font-size: 12px;
        color: $dim-gray-color;
        position: absolute;
        right: 20px;
    }
    .icon-collapse {
        margin-right: 4px;
    }
    .tool-box {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 22;
        .dropdown-label {
            display: inline-block;
        }
        .icons {
            padding: 4px 0;
            margin-left:24px;
        }
        .icon-mail-more{
            margin-top:-4px;
            vertical-align: middle;
        }
        .dropdown-list {
            width: 170px;
            line-height: 28px;
            overflow-y: auto;
            background: #fff;
            color: #505060;
            z-index: 22;
            box-shadow: 0 3px 9px rgba(0, 0, 0, 0.2);
             > li {
                padding-left: 28px;
                font-size: 12px;
                z-index: 22;
                cursor: pointer;
                &:hover,
                .active {
                    background: #f3f3f3;
                }
                &.picon{
                    padding-left: 10px;
                }
            }
            .icon-arrow-right {
                padding: 0;
            }
            .icon-unread-round {              
                display: inline-block;
                width:10px;
                height:10px;
                border-radius: 50%;
                border:1px solid #457EFF;
                margin-right: 6px;
            }
            .icon-star{
                margin:0 6px 0 0;
            }
            .bb{
                border-bottom: 1px solid #F3F3F3;
            }
            .list2 {
                width: 104px;
                max-height: 200px;                
                > li {
                    padding-left: 10px;                    
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .dropdown-more {
                padding-left: 0;
                .dropdown-label {
                    width: 100%;
                    padding-left: 28px;
                }
                .icon-arrow-right {
                    float: right;
                    margin-top: 10px;
                    margin-right: 10px;
                }
            }
        }
        .icon-close-win{
            &:hover .close-tip{
                opacity: 1;
                visibility: visible
            }
        }
        .close-tip{
            position: absolute;
            right:-10px;
            top:32px;
            background: #D19F4E;
            color:#fff;
            font-size:12px;
            font-weight:500;
            padding: 6px;
            border-radius:2px;
            box-shadow:0px 2px 4px 0px rgba(0,0,0,0.5);
            visibility: hidden;
            opacity: 0;
            transition: all .3s;
            &:before{
                content:'';
                position: absolute;
                top:-12px;
                right:6px;
                border: 6px solid;
                border-color:transparent transparent #D19F4E transparent
            }
        }
    }
}
.item-detail {
    margin: 0 10px;
    padding:0 20px;
    background: #fff;
    border:1px solid #D2D2D2;
    box-shadow:2px 2px 6px 0px rgba(0,0,0,0.2);
    // border-bottom: 1px solid $light-gray-color;
    .content {
        font-size: 13px;
        color: #000;
        min-height: 93px;
        padding: 15px 0;
    }
}
.mail-header {
    font-size: 12px;
    color: #000;
    padding: 14px 0;
    position: relative;
    border-bottom: 1px solid $light-gray-color;
    .img-block {
        margin: 0 16px 0 0;
        vertical-align: top;
    }
    .info-box {
        display: inline-block;
        width: calc(100% - 56px);
    }
    .sender,
    .sender-to,
    .carbon-copy {
        position: relative;
        label {
            width: 48px;
            color: $dim-gray-color;
            position: absolute;
            top: 4px;
        }
        .mail-address-block {
            display: inline-block;
            margin-left: 48px;
        }
        .icons {
            margin-left: 10px;
            cursor: pointer;
        }
    }

    .address-box {
        display: inline-block;
        min-height: 20px;
        margin-right: 7px;
        margin-bottom: 10px;
        color: $dim-gray-color;
        position: relative;
        .name {
            background: rgba(69, 126, 236, 0.3);
            display: inline-block;
            line-height: 20px;
            padding: 0px 4px;
            border-radius: 10px;
        }
        .icons-box {
            display: inline-block;
            vertical-align: bottom;
            width: 20px;
            height: 20px;
            background: rgba(69, 126, 236, 0.3);
            border-radius: 2px;
        }
    }
    .recieve-time {
        position: absolute;
        top:20px;
        right:0;
        margin-bottom: 10px;
        color: #626270;
        label {
            display: inline-block;
            width: 48px;
            color: $dim-gray-color;
        }
    }
     .expand-block{
        position: absolute;
        bottom:20px;
        right:0;  
        cursor: pointer;   
    }
    .accessory {
        label {
            display: inline-block;
            width: 48px;
            color: $dim-gray-color;
        }
        .accessory-text {
            color: #000;
        }
        .see-attachments {
            color: #0f409f;
            text-decoration: underline;
            cursor: pointer;
            &:hover {
                color: #457eec;
            }
        }
    }
    .info-item {
        &:last-child {
            margin-bottom: 0;
        }
    }
}
.attachments {
    border-top:1px solid #D0D0D0;
    padding-bottom: 60px;
    .attach-tit {
        font-size: 12px;
        color: #505060;
        line-height: 43px;
        .name {
            color: #000;
        }
        .bagdownall {
            margin-left: 10px;
            color: #0f409f;
            text-decoration: underline;
            cursor: pointer;
            &:hover {
                color: #457eec;
            }
        }
        .icon-expand,
        .icon-collapse {
            margin-right: 4px;
        }
    }
    .list {
        padding: 0px 0 20px;
        .item {
            width: 240px;
            height: 40px;
            background: #e3e3e3;
            border-radius: 2px;
            float: left;
            padding: 6px 4px;
            margin-top: 10px;
            margin-right: 30px;
            position: relative;
            .ac-hover {
                display: none;
                position: absolute;
                // background: rgba(0, 0, 0, 0.5);
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                .icon-download {
                    position: absolute;
                    right: 20px;
                    top: 10px;
                }
            }
            &:hover {
                .name {
                    color: rgba(0, 0, 0, 0.2);
                }
                .size {
                    color: rgba(138, 138, 138, 0.2);
                }
                .ac-hover {
                    display: block;
                }
            }
        }

        .expand-btn {
            font-size: 12px;
            color: #505060;
            margin-top: 15px;
            &:hover {
                color: #000;
            }
        }
        .img-type {
            margin-right: 6px;
        }
        p {
            margin: 0;
        }
        .msg {
            display: inline-block;
            font-size: 12px;
            vertical-align: bottom;
        }
        .name {
            display: inline-block;
            width: 190px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #000;
            margin-bottom: 2px;
        }
        .size {
            color: #8a8a8a;
        }
    }
}
.quick-reply-wrap {
    position: fixed;
    bottom:10px;
    right:10px;
    z-index:999;
    padding: 10px;
    border-bottom: 1px solid #d0d0d0;
    &.noborder {
        border-bottom: 0;
    }
    .reply-simple {
        width: 360px;
        height:36px;
        line-height:36px;
        padding:0 20px;
        font-size:12px;
        color:#000;
        font-weight: 500;
        background: #EFEFEF;
        box-shadow:2px 2px 6px 0px rgba(0,0,0,0.4);
        border-radius:3px;
        cursor: pointer;
        .text{
            display: inline-block;
            vertical-align: middle;
            width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .reply-box {
        width: 850px;
        height:300px;
        // padding: 10px;
        background: #fff;
        box-shadow:2px 2px 6px 0px rgba(0,0,0,0.4);
        // border: 1px solid #d0d0d0;
        border-radius:4px;
        .tit {
            background: #EFEFEF;
            color: #000;
            font-size: 12px;
            font-weight: 500;
            padding: 10px 20px;
        }
        textarea {
            height: 226px;
            font-size: 12px;
            line-height: 16px;
            color: #000;
            width: 100%;
            padding: 10px;
            border: 0;
            overflow-y: scroll;
            resize: none;
        }
        .send-block {
            text-align: right;
            margin-right: 10px;
            .text {
                font-size: 12px;
                color: #505060;
                text-decoration: underline;
                cursor: pointer;
                &:hover {
                    color: #000;
                }
            }
        }
        .send-btn {
            display: inline-block;
            width: 100px;
            line-height: 28px;
            text-align: center;
            background: #457eec;
            font-size: 12px;
            color: #fff;
            margin-left: 20px;
            cursor: pointer;
            &:hover {
                background: #0f409f;
            }
        }
    }
}
.dropmenu {
    visibility: hidden;
    opacity: 0;
    transition: all .3s;
}
.address-box:hover {
    .dropmenu {
        opacity: 1;
        visibility: visible
    }
}
.iframepage {
    position: relative;
    z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/page/mail/readMail.vue